const mappingUavosReducer = (state = {}, action) => {
  switch (action.type) {
    case 'SET_MAPPING_UAVOS':
      return { ...action.payload };
    default:
      return state;
  }
};

export default mappingUavosReducer;
